import { initializeApp, getApps, getApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDxPm8XXWzVOTcfFEXnarQ4JX478m_WOKk",
  authDomain: "ekkos-c7955.firebaseapp.com",
  projectId: "ekkos-c7955",
  storageBucket: "ekkos-c7955.appspot.com",
  messagingSenderId: "616241405421",
  appId: "1:616241405421:web:7c444df8b9c5ce2c489be4",
  measurementId: "G-T9DKRS87M2"
};

let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp(); // if already initialized, use that one
}




export { app as firebase };
